import { ActionMeta } from 'react-select'

import { Option, Options } from './types'

export const isSelectOption = (option: Option | unknown): option is Option => {
  return (
    typeof option === 'object' &&
    option !== null &&
    'value' in option &&
    'label' in option &&
    typeof (option as Option).label === 'string'
  )
}

export const isSelectOptions = (
  options: Options | unknown,
): options is Options => {
  return Array.isArray(options)
}

export const getOnChangeFunctionSafely = (
  onChange: (...event: unknown[]) => void,
  val?: unknown,
  action?: ActionMeta<unknown>,
) => {
  if (val == null) {
    return onChange(null, action)
  }

  if (isSelectOption(val)) {
    return onChange(val?.value, action)
  }

  if (isSelectOptions(val)) {
    return onChange(
      val?.map((e) => e.value),
      action,
    )
  }
}

export const getDefaultValueSafely = (
  defaultValue: unknown,
  options?: Option[],
) => {
  if (Array.isArray(defaultValue)) {
    return options?.filter((e) => defaultValue.includes(e.value))
  }

  if (isSelectOption(defaultValue)) {
    return defaultValue
  } else {
    return options?.find((option) => option.value === defaultValue)
  }
}
